import {ClarityWindow} from '@src/utility/logger/libs/clarity/type'

export const clarityAvailable = (): boolean => {
  return typeof (window as ClarityWindow)?.clarity === 'function'
}
